import { RenderUnsettledUI, SmallError, SmallLoader } from 'shared/components';
import { useOgpGetShift } from 'shared/components/shift-forms/hooks/ogp/use-ogp-get-shift';
import { useSiteDetection } from 'shared/hooks';
import { ShiftDetailsModal } from './shift-details-modal';

type ShiftDetailsProviderProps = {
  shiftId: string;
};

export const ShiftDetailsProvider = ({ shiftId }: ShiftDetailsProviderProps) => {
  const siteDetectionResult = useSiteDetection();
  const shiftQuery = useOgpGetShift(siteDetectionResult.site, shiftId);

  if (shiftQuery.status !== 'success') {
    return (
      <RenderUnsettledUI
        renderLoading={<SmallLoader />}
        renderError={(error) => <SmallError error={error} />}
        data={shiftQuery}
      />
    );
  }

  return <ShiftDetailsModal data={shiftQuery.data} />;
};
